<template>
  <div class="multi-line-input" :class="[ isFocus ? 'focus' : '' ]">
    <el-input
      v-for="(item, index) in values" :key="index"
      v-model="values[index]"
      :maxlength="maxLength"
      show-word-limit
      :placeholder="placeholder[index]"
      @blur="handleBlur"
      @focus="handleFocus"
      @keyup.enter="handleEnter"></el-input>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => (['', '', '']),
    },
    maxLength: {
      type: Number,
      default: 35,
    },
    placeholder: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      values: ['', '', ''],
      isFocus: false,
    };
  },
  created() {
    this.values = this.data;
  },
  watch: {
    data() {
      this.values = this.data;
    },
  },
  methods: {
    handleBlur() {
      this.isFocus = false;
    },

    handleFocus() {
      this.isFocus = true;
    },

    handleEnter() {
      //
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.multi-line-input {
  background-color: $color-default;
  border-radius: 4px;

  &.focus {
    background-color: white;
    box-shadow: 0 0 0 2px $color-default inset;
  }

  .el-input {
    background-color: transparent;
  }
  .el-input {
    background: transparent;

    &.is-focus {
      box-shadow: none;
    }
    &:hover {
      box-shadow: none;
    }
    .el-input__inner {
      border-color: transparent;
      background: transparent;

      &:active, &:focus {
        background-color: transparent;
        border-color: transparent;
      }
      &:hover {
        border-color: transparent;
      }
    }
  }
  .el-input .el-input__count .el-input__count-inner {
    background-color: transparent;
    color: #264373;
    padding-right: 8px;
  }
}
</style>
